import { Box, styled, Text, useTheme, Button } from '@/theme/index';
import { useRedirect } from '@/utils/hooks/useRedirect';
import { UnclaimedMoneyResultsInformationProps } from '../interfaces';

const InformationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: theme.spacing(5),
}));

const LinkButton = styled(Button)({
  textDecoration: 'underline',
  ':hover': { backgroundColor: 'inherit' },
  padding: 0,
  lineHeight: 1.2,
  verticalAlign: 'baseline',
});

export function UnclaimedMoneyResultsInformation({
  informationImage,
  title,
  subTitle,
  noResults = false,
  reloadAvailable = false,
}: UnclaimedMoneyResultsInformationProps) {
  const theme = useTheme();
  const { redirect } = useRedirect();

  const reloadPage = () => {
    window.location.reload();
  };

  const handleRedirect = () => {
    redirect('/dashboard/unclaimed-money');
  };

  return (
    <InformationContainer>
      <img src={informationImage} alt="Robot with Information" />
      <Text variant="h5" marginTop={4}>
        {title}
      </Text>
      {noResults ? (
        <Text variant="body2" marginBottom={6}>
          {subTitle}{' '}
          <LinkButton variant="text" onClick={handleRedirect}>
            or start a new search
          </LinkButton>
        </Text>
      ) : (
        <Text variant="body2" marginBottom={6}>
          {subTitle}
        </Text>
      )}

      {reloadAvailable && (
        <Button
          variant="contained"
          onClick={reloadPage}
          sx={{
            color: theme.palette.success.contrastText,
            backgroundColor: theme.palette.success.main,
            '&:hover': {
              backgroundColor: theme.palette.success.dark,
            },
          }}
        >
          Reload now
        </Button>
      )}
    </InformationContainer>
  );
}
